var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYouTube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#FE2905"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.997 37.7892C72.445 35.5105 70.8185 33.7158 68.7533 33.1067C65.01 32 50 32 50 32C50 32 34.9901 32 31.2467 33.1067C29.1815 33.7159 27.555 35.5105 27.003 37.7892C26 41.9197 26 50.5374 26 50.5374C26 50.5374 26 59.1551 27.003 63.2855C27.555 65.5643 29.1815 67.2842 31.2467 67.8933C34.9901 69 50 69 50 69C50 69 65.0099 69 68.7533 67.8933C70.8185 67.2842 72.445 65.5643 72.997 63.2855C74 59.1551 74 50.5374 74 50.5374C74 50.5374 74 41.9197 72.997 37.7892ZM45.0909 58.3616V42.7131L57.6363 50.5376L45.0909 58.3616Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/YouTube.cd13b4a47ea428dd844fcefd477567b1.svg";
export { ForwardRef as ReactComponent };